<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-form-group
          label="Crop"
          :label-cols="3"
          :state="!$v.sample_form.sample_tissue.crop.$invalid"
          invalid-feedback="Required"
        >
          <form-selector
            :selectedItem="sample_form.sample_tissue.crop"
            :customPlaceholder="'Select Sample Crop'"
            :options="cropOptions"
            @change="handleSelect"
          ></form-selector>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          label="Crop Stage"
          :label-cols="3"
          :disabled="!sample_form.sample_tissue.crop"
          :state="!$v.sample_form.sample_tissue.cropstage.$invalid"
          invalid-feedback="Required"
        >
          <form-selector
            :selectedItem="sample_form.sample_tissue.cropstage"
            :customPlaceholder="'Select Sample Crop Stage'"
            :options="crop_stage_options"
            @change="handleSelect"
          ></form-selector>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FormSelector from "../../FormSelector";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  name: "TissueCropFormGroups",
  components: {
    FormSelector
  },
  mixins: [validationMixin, ToastNotifications],
  props: ["submission", "index", "cropOptions", "cropStageOptions"],
  computed: {
    crop_stage_options() {
      return {
        ...this.cropStageOptions,
        options: this.cropStageOptions.options.filter(
          option => option.parent_id === this.sample_form.sample_tissue.crop
        )
      };
    }
  },
  data() {
    return {
      sample_form: {
        sample_tissue: {
          crop: null,
          cropstage: null
        }
      }
    };
  },
  validations: {
    sample_form: {
      sample_tissue: {
        crop: { required },
        cropstage: { required }
      }
    }
  },
  methods: {
    handleSelect({ selected, field }) {
      this.sample_form.sample_tissue[field] = selected;
      if (field === "crop") {
        this.sample_form.sample_tissue.cropstage = null;
      }
    }
  },
  watch: {
    sample_form: {
      handler() {
        this.$emit("onCropChange", this.sample_form.sample_tissue);
      },
      deep: true
    },
    submission: {
      handler(value) {
        this.sample_form.sample_tissue.crop = value.submission_tissue.crop;
        this.sample_form.sample_tissue.cropstage =
          value.submission_tissue.cropstage;
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
